/**
 * https://react-redux.js.org/api/hooks#useselector
 */
import {useSelector} from "react-redux";
import {ISettings} from "core/models/ISettings";

const getSettings = (state: any): ISettings => state.user.settings

export default function  useSettings(): ISettings {
  return useSelector(getSettings)
}
